(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/behaviors/payfooter-analytics.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/behaviors/payfooter-analytics.js');

'use strict';

svs.numbergames.game.behaviors.PayfooterAnalytics = Marionette.Behavior.extend({
  onInitialize() {
    var _this$getOption;
    svs.numbergames.game.logger.debug('PayfooterAnalytics onInitialize');
    const eventMap = this.createEventMap();
    (_this$getOption = this.getOption('analyticsEvents')) === null || _this$getOption === void 0 || _this$getOption.forEach(ev => {
      var _eventMap$ev;
      return (_eventMap$ev = eventMap[ev]) === null || _eventMap$ev === void 0 ? void 0 : _eventMap$ev.call(eventMap);
    });
  },
  createEventMap() {
    const _svs$numbergames$game = svs.numbergames.game.analytics_events,
      BETSLIP_COMPLETE = _svs$numbergames$game.BETSLIP_COMPLETE,
      BETROW_STARTED_COMPLETE = _svs$numbergames$game.BETROW_STARTED_COMPLETE;
    const model = this.view.model;
    const boards = model.get('boards');
    return {
      [BETROW_STARTED_COMPLETE]: () => {
        this.listenTo(boards, 'change', board => {
          if (board.isPreHuxfluxing) return;
          if (board.changed.isEmpty === false) {
            this.trackEvent('Betrow Started');
          }
          if (board.changed.isValid === true) {
            this.trackEvent('Betrow Complete');
          }
        });
      },
      [BETSLIP_COMPLETE]: () => {
        this.listenTo(model, 'change:isValid', (model, isValid) => isValid && requestAnimationFrame(() => this.trackEvent('Betslip Complete')));
      }
    };
  },
  trackEvent(action) {
    if (!(action !== null && action !== void 0 && action.length)) {
      svs.numbergames.game.logger.info('PayfooterAnalytics missing action. No analytics sent');
      return;
    }
    const productName = svs.numbergames.productMapping.getProductName(this.view.model.get('productId'));
    let gameType = 'Enkelrader';
    if (this.view.model.get('isSystem')) {
      gameType = 'System';
    } else if (this.view.model.get('isPackage')) {
      gameType = 'Paket';
    }
    const event = {
      category: 'Wager',
      action,
      opt_label: "".concat(productName, ":").concat(gameType)
    };
    svs.numbergames.game.logger.debug('PayfooterAnalytics trackEvent', event);
    svs.components.analytics.trackEvent(event);
  }
});

 })(window);